import { AnimatePresence, motion } from "framer-motion";
import { useViewStore } from "../store/view-store";
import { slideVariants } from "../lib/slideVariants";

import { CalendarPage } from "./pages/calendar-page";
import { LoginPage } from "./pages/login-page";
import ProfilePage from "./pages/profile/profile-page";
import BookingPage from "./pages/booking";
import ForgotPassword from "./pages/password";
import PackagesPage from "./pages/packages-page";
import PrivateBookingPage from "./pages/private-booking-page";
import { useEffect } from "react";

export function WidgetContent() {
  const { current, direction } = useViewStore();

  // 👇 Auto-scroll to top on every view change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [current]);

  function renderView(view: string) {
    switch (view) {
      case "calendar":
        return <CalendarPage />;
      case "packages":
        return <PackagesPage />;
      case "login":
        return <LoginPage />;
      case "password":
        return <ForgotPassword />;
      case "profile":
        return <ProfilePage />;
      case "booking":
        return <BookingPage />;
      case "private-booking":
        return <PrivateBookingPage />;
      default:
        return null;
    }
  }

  return (
    <div className="relative w-full">
      <AnimatePresence initial={false} custom={direction} mode="wait">
        <motion.div
          key={current}
          custom={direction}
          variants={slideVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { type: "tween", duration: 0.2 },
            opacity: { duration: 0.2 },
          }}
          onAnimationComplete={() => {
            const height = document.documentElement.scrollHeight;
            window.parent.postMessage(
              { type: "WIDGET_RESIZE", height: height + 20 },
              "*",
            );
          }}
          className="w-full"
        >
          {renderView(current)}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
